// import React, { useState } from "react";
// import { Modal, Button } from "react-bootstrap";
// import { Star, X, Send } from "lucide-react";
// import { URL } from "../../../config";

// // Star rating component
// const StarRating = ({ rating, setRating }) => {
//   const starValues = [1, 2, 3, 4, 5];
//   return (
//     <div style={{ marginBottom: "1.5rem" }}>
//       <h3 style={{ fontSize: "1rem", fontWeight: "600", marginBottom: "1rem", textAlign: "center" }}>
//         Rate your experience
//       </h3>
//       <div style={{ display: "flex", justifyContent: "center", gap: "0.5rem" }}>
//         {starValues.map((value) => {
//           const isFilled = value <= rating;
//           return (
//             <button
//               key={value}
//               onClick={() => setRating(value)}
//               onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
//               onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
//               style={{
//                 backgroundColor: "transparent",
//                 border: "none",
//                 cursor: "pointer",
//                 transform: "scale(1)",
//                 transition: "transform 0.2s",
//                 padding: 0,
//               }}
//               title={
//                 value === 1
//                   ? "Very Poor"
//                   : value === 2
//                   ? "Poor"
//                   : value === 3
//                   ? "Average"
//                   : value === 4
//                   ? "Good"
//                   : "Excellent"
//               }
//             >
//               <Star
//                 size={32}
//                 style={{
//                   color: isFilled ? "#FBBF24" : "#D1D5DB",
//                   fill: isFilled ? "#FBBF24" : "none",
//                   transition: "color 0.2s",
//                 }}
//               />
//             </button>
//           );
//         })}
//       </div>
//     </div>
//   );
// };

// // "Thank You" modal displayed after successful submission
// const ThankYouModal = ({ onClose }) => {
//   return (
//     <Modal show onHide={onClose} centered>
//       <Modal.Header
//         style={{
//           borderBottom: "1px solid #e5e7eb",
//           padding: "1rem 1.5rem",
//           position: "relative",
//         }}
//       >
//         <button
//           type="button"
//           onClick={onClose}
//           style={{
//             position: "absolute",
//             top: "0.75rem",
//             right: "1rem",
//             backgroundColor: "transparent",
//             border: "none",
//             color: "#6b7280",
//             cursor: "pointer",
//             padding: "0.25rem",
//             borderRadius: "0.25rem",
//           }}
//           onMouseOver={(e) => (e.currentTarget.style.color = "#000")}
//           onMouseOut={(e) => (e.currentTarget.style.color = "#6b7280")}
//         >
//           <X size={20} />
//         </button>
//         <Modal.Title style={{ fontWeight: "bold", fontSize: "1.2rem", margin: "0 auto" }}>
//           Thank You!
//         </Modal.Title>
//       </Modal.Header>
//       <Modal.Body style={{ textAlign: "center", padding: "1.5rem" }}>
//         <p style={{ fontSize: "1rem", margin: 0 }}>
//           Thank you for your feedback! We appreciate your time and trust in our service.
//           We hope to serve you again soon.
//         </p>
//         <strong>Stay with HelpNao 😃</strong>
//       </Modal.Body>
//       <Modal.Footer style={{ justifyContent: "center", borderTop: "1px solid #e5e7eb" }}>
//         <Button variant="primary" onClick={onClose} style={{ padding: "0.5rem 1.5rem" }}>
//           OK
//         </Button>
//       </Modal.Footer>
//     </Modal>
//   );
// };

// const TransactionModal = ({ order, onClose, onSuccess }) => {
//   const [rating, setRating] = useState(0);
//   const [selectedOption, setSelectedOption] = useState("");
//   const [otherFeedback, setOtherFeedback] = useState("");
//   const [submitting, setSubmitting] = useState(false);
//   const [showThankYou, setShowThankYou] = useState(false);

//   // feedback options
//   const feedbackOptions = [
//     {
//       id: "excellent",
//       label: "Excellent experience",
//       icon: "🌟",
//       bgColor: "#D1FAE5",
//       borderColor: "#A7F3D0",
//       textColor: "#065F46",
//     },
//     {
//       id: "good",
//       label: "Good service",
//       icon: "👍",
//       bgColor: "#DBEAFE",
//       borderColor: "#BFDBFE",
//       textColor: "#1E3A8A",
//     },
//     {
//       id: "slow",
//       label: "Service was very slow",
//       icon: "⏱",
//       bgColor: "#FEF3C7",
//       borderColor: "#FDE68A",
//       textColor: "#92400E",
//     },
//     {
//       id: "communication",
//       label: "Poor communication",
//       icon: "💬",
//       bgColor: "#FEE2E2",
//       borderColor: "#FECACA",
//       textColor: "#991B1B",
//     },
//     {
//       id: "value",
//       label: "Value for money",
//       icon: "💲",
//       bgColor: "#E0F2FE",
//       borderColor: "#BAE6FD",
//       textColor: "#0C4A6E",
//     },
//     {
//       id: "unsatisfied",
//       label: "Not satisfied with the work",
//       icon: "😕",
//       bgColor: "#EDE9FE",
//       borderColor: "#DDD6FE",
//       textColor: "#5B21B6",
//     },
//     {
//       id: "other",
//       label: "Other (please specify)",
//       icon: "✍",
//       bgColor: "#F3F4F6",
//       borderColor: "#E5E7EB",
//       textColor: "#374151",
//     },
//   ];

//   // Get final feedback text
//   const getFinalFeedback = () => {
//     const selected = feedbackOptions.find((opt) => opt.id === selectedOption);
//     if (selectedOption === "other") {
//       return otherFeedback;
//     } else if (selected) {
//       return selected.label;
//     }
//     return "";
//   };

//   // Submit data to the backend
//   const handleSubmit = async () => {
//     const totalAmount = order.price;
//     const commissionAmount = totalAmount * 0.05;
//     const netAmount = totalAmount - commissionAmount;
//     const finalFeedback = getFinalFeedback();

//     const payload = {
//       orderId: order.Id,
//       // order_number: order.order_number,
//       servitorId: order.servitor_id,
//       userId: order.userId,
//       serviceId: order.serviceId,
//       serviceType: order.Service?.services_name || "Unknown",
//       totalAmount,
//       commissionAmount,
//       netAmount,
//       rating,
//       feedback: finalFeedback,
//     };

//     console.log("Data",payload);

//     try {
//       setSubmitting(true);
//       const response = await fetch(`${URL}/orders/${order.Id}/completeTransaction`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload),
//       });
//       if (response.ok) {
//         // Hide the Transaction modal and show Thank You modal
//         setShowThankYou(true);
//       } else {
//         const text = await response.text();
//         let errorData;
//         try {
//           errorData = text ? JSON.parse(text) : { message: text };
//         } catch (e) {
//           errorData = { message: text };
//         }
//         console.error("Failed to complete transaction:", errorData.message);
//       }
//     } catch (error) {
//       console.error("Error completing transaction:", error);
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   const handleThankYouClose = () => {
//     setShowThankYou(false);
//     onSuccess();
//   };

//   // Separate first six options and the "other" option
//   const firstSixOptions = feedbackOptions.slice(0, 6);
//   const otherOption = feedbackOptions[6];

//   // If submission is successful, render only the Thank You modal
//   if (showThankYou) {
//     return <ThankYouModal onClose={handleThankYouClose} />;
//   }

//   return (
//     <Modal
//       show
//       onHide={onClose}
//       centered
//       backdrop="static"
//       keyboard={false}
//       style={{ marginTop: "20px" }}
//       dialogClassName="custom-wide-modal"
//     >
//       {/* Header */}
//       <Modal.Header
//         style={{
//           borderBottom: "1px solid #e5e7eb",
//           padding: "1rem 1.5rem",
//           position: "relative",
//         }}
//       >
//         <button
//           type="button"
//           onClick={onClose}
//           style={{
//             position: "absolute",
//             top: "0.75rem",
//             right: "1rem",
//             backgroundColor: "transparent",
//             border: "none",
//             color: "#6b7280",
//             cursor: "pointer",
//             padding: "0.25rem",
//             borderRadius: "0.25rem",
//           }}
//           onMouseOver={(e) => (e.currentTarget.style.color = "#000")}
//           onMouseOut={(e) => (e.currentTarget.style.color = "#6b7280")}
//         >
//           <X size={20} />
//         </button>
//         <Modal.Title style={{ fontSize: "1.25rem", fontWeight: "bold", margin: "0 auto" }}>
//           Complete Service Transaction
//         </Modal.Title>
//       </Modal.Header>

//       {/* Body */}
//       <Modal.Body style={{ padding: "1.5rem" }}>
//         <p style={{ color: "#4b5563", margin: 0, marginBottom: "1rem", fontSize: "0.95rem" }}>
//           Thank you for taking{" "}
//           <span style={{ fontWeight: 600 }}>
//             {order.Service ? order.Service.services_name : "the service"}
//           </span>{" "}
//           from us. Stay with HelpNao.
//         </p>
//         <hr style={{ marginBottom: "1rem" }} />

//         {/* Star Rating */}
//         <StarRating rating={rating} setRating={setRating} />

//         {/* Feedback Options */}
//         <h3 style={{ fontSize: "1rem", fontWeight: "600", marginBottom: "1rem" }}>
//           How was your experience?
//         </h3>

//         {/* 2-column grid for first six options */}
//         <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.75rem" }}>
//           {firstSixOptions.map((option) => {
//             const isSelected = selectedOption === option.id;
//             return (
//               <label
//                 key={option.id}
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   padding: "0.75rem",
//                   borderRadius: "0.75rem",
//                   cursor: "pointer",
//                   transition: "all 0.2s",
//                   border: isSelected ? `2px solid ${option.borderColor}` : "1px solid #e5e7eb",
//                   backgroundColor: isSelected ? option.bgColor : "#fff",
//                 }}
//                 onClick={() => {
//                   setSelectedOption(option.id);
//                   if (option.id !== "other") setOtherFeedback("");
//                 }}
//               >
//                 <input
//                   type="radio"
//                   name="feedback"
//                   value={option.id}
//                   checked={selectedOption === option.id}
//                   readOnly
//                   style={{ width: "1rem", height: "1rem" }}
//                 />
//                 <span style={{ marginLeft: "0.75rem", fontSize: "1.2rem" }}>
//                   {option.icon}
//                 </span>
//                 <span
//                   style={{
//                     marginLeft: "0.5rem",
//                     fontSize: "0.95rem",
//                     color: isSelected ? option.textColor : "#374151",
//                   }}
//                 >
//                   {option.label}
//                 </span>
//               </label>
//             );
//           })}
//         </div>

//         {/* "Other" option full row */}
//         <div
//           style={{
//             marginTop: "0.75rem",
//             display: "flex",
//             alignItems: "center",
//             padding: "0.75rem",
//             borderRadius: "0.75rem",
//             cursor: "pointer",
//             transition: "all 0.2s",
//             border:
//               selectedOption === otherOption.id
//                 ? `2px solid ${otherOption.borderColor}`
//                 : "1px solid #e5e7eb",
//             backgroundColor: selectedOption === otherOption.id ? otherOption.bgColor : "#fff",
//           }}
//           onClick={() => setSelectedOption(otherOption.id)}
//         >
//           <input
//             type="radio"
//             name="feedback"
//             value={otherOption.id}
//             checked={selectedOption === otherOption.id}
//             readOnly
//             style={{ width: "1rem", height: "1rem" }}
//           />
//           <span style={{ marginLeft: "0.75rem", fontSize: "1.2rem" }}>{otherOption.icon}</span>
//           <span
//             style={{
//               marginLeft: "0.5rem",
//               fontSize: "0.95rem",
//               color: selectedOption === otherOption.id ? otherOption.textColor : "#374151",
//             }}
//           >
//             {otherOption.label}
//           </span>
//         </div>

//         {/* Textarea for "Other" feedback */}
//         {selectedOption === "other" && (
//           <div style={{ marginTop: "1rem" }}>
//             <label
//               style={{
//                 display: "block",
//                 marginBottom: "0.5rem",
//                 fontSize: "0.9rem",
//                 fontWeight: 500,
//                 color: "#374151",
//               }}
//             >
//               Please provide more details
//             </label>
//             <textarea
//               value={otherFeedback}
//               onChange={(e) => setOtherFeedback(e.target.value)}
//               style={{
//                 width: "100%",
//                 height: "80px",
//                 padding: "0.75rem",
//                 borderRadius: "0.75rem",
//                 border: "1px solid #e5e7eb",
//                 fontSize: "0.9rem",
//                 resize: "none",
//                 outline: "none",
//               }}
//               placeholder="Tell us more about your experience..."
//             />
//           </div>
//         )}
//       </Modal.Body>

//       {/* Footer */}
//       <Modal.Footer
//         style={{
//           borderTop: "1px solid #e5e7eb",
//           padding: "1rem 1.5rem",
//           display: "flex",
//           gap: "1rem",
//           backgroundColor: "#f9fafb",
//           borderRadius: "0 0 0.75rem 0.75rem",
//         }}
//       >
//         <Button
//           onClick={onClose}
//           disabled={submitting}
//           style={{
//             flex: 1,
//             padding: "0.75rem 1rem",
//             border: "1px solid #d1d5db",
//             borderRadius: "0.75rem",
//             fontSize: "0.95rem",
//             fontWeight: 500,
//             color: "#374151",
//             backgroundColor: "#fff",
//           }}
//         >
//           Cancel
//         </Button>
//         <Button
//           onClick={handleSubmit}
//           disabled={submitting}
//           style={{
//             flex: 1,
//             padding: "0.75rem 1rem",
//             border: "none",
//             borderRadius: "0.75rem",
//             fontSize: "0.95rem",
//             fontWeight: 500,
//             color: "#fff",
//             backgroundColor: "#3B82F6",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             gap: "0.5rem",
//           }}
//           onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#2563EB")}
//           onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#3B82F6")}
//         >
//           <Send size={16} />
//           {submitting ? "Submitting..." : "Submit Feedback"}
//         </Button>
//       </Modal.Footer>
//     </Modal>
//   );
// };

// export default TransactionModal;










///////////////******** New Design with css and responsive *********////////////////



// import React, { useState } from "react";
// import { Modal, Button } from "react-bootstrap";
// import { Star, X, Send } from "lucide-react";
// import { URL } from "../../../config";
// import "./TransactionModal.css";


// // Star rating component
// const StarRating = ({ rating, setRating }) => {
//   const starValues = [1, 2, 3, 4, 5];
//   return (
//     <div style={{ marginBottom: "1.5rem" }}>
//       <h3 style={{ fontSize: "1rem", fontWeight: "600", marginBottom: "1rem", textAlign: "center" }}>
//         Rate your experience
//       </h3>
//       <div style={{ display: "flex", justifyContent: "center", gap: "0.5rem" }}>
//         {starValues.map((value) => {
//           const isFilled = value <= rating;
//           return (
//             <button
//               key={value}
//               onClick={() => setRating(value)}
//               onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
//               onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
//               style={{
//                 backgroundColor: "transparent",
//                 border: "none",
//                 cursor: "pointer",
//                 transform: "scale(1)",
//                 transition: "transform 0.2s",
//                 padding: 0,
//               }}
//               title={
//                 value === 1
//                   ? "Very Poor"
//                   : value === 2
//                   ? "Poor"
//                   : value === 3
//                   ? "Average"
//                   : value === 4
//                   ? "Good"
//                   : "Excellent"
//               }
//             >
//               <Star
//                 size={32}
//                 style={{
//                   color: isFilled ? "#FBBF24" : "#D1D5DB",
//                   fill: isFilled ? "#FBBF24" : "none",
//                   transition: "color 0.2s",
//                 }}
//               />
//             </button>
//           );
//         })}
//       </div>
//     </div>
//   );
// };

// // "Thank You" modal displayed after successful submission
// const ThankYouModal = ({ onClose }) => {
//   return (
//     <Modal show onHide={onClose} centered>
//       <Modal.Header
//         style={{
//           borderBottom: "1px solid #e5e7eb",
//           padding: "1rem 1.5rem",
//           position: "relative",
//         }}
//       >
//         <button
//           type="button"
//           onClick={onClose}
//           style={{
//             position: "absolute",
//             top: "0.75rem",
//             right: "1rem",
//             backgroundColor: "transparent",
//             border: "none",
//             color: "#6b7280",
//             cursor: "pointer",
//             padding: "0.25rem",
//             borderRadius: "0.25rem",
//           }}
//           onMouseOver={(e) => (e.currentTarget.style.color = "#000")}
//           onMouseOut={(e) => (e.currentTarget.style.color = "#6b7280")}
//         >
//           <X size={20} />
//         </button>
//         <Modal.Title style={{ fontWeight: "bold", fontSize: "1.2rem", margin: "0 auto" }}>
//           Thank You!
//         </Modal.Title>
//       </Modal.Header>
//       <Modal.Body style={{ textAlign: "center", padding: "1.5rem" }}>
//         <p style={{ fontSize: "1rem", margin: 0 }}>
//           Thank you for your feedback! We appreciate your time and trust in our service.
//           We hope to serve you again soon.
//         </p>
//         <strong>Stay with HelpNao 😃</strong>
//       </Modal.Body>
//       <Modal.Footer style={{ justifyContent: "center", borderTop: "1px solid #e5e7eb" }}>
//         <Button variant="primary" onClick={onClose} style={{ padding: "0.5rem 1.5rem" }}>
//           OK
//         </Button>
//       </Modal.Footer>
//     </Modal>
//   );
// };

// const TransactionModal = ({ order, onClose, onSuccess }) => {
//   const [rating, setRating] = useState(0);
//   const [selectedOption, setSelectedOption] = useState("");
//   const [otherFeedback, setOtherFeedback] = useState("");
//   const [submitting, setSubmitting] = useState(false);
//   const [showThankYou, setShowThankYou] = useState(false);

//   // feedback options
//   const feedbackOptions = [
//     {
//       id: "excellent",
//       label: "Excellent experience",
//       icon: "🌟",
//       bgColor: "#D1FAE5",
//       borderColor: "#A7F3D0",
//       textColor: "#065F46",
//     },
//     {
//       id: "good",
//       label: "Good service",
//       icon: "👍",
//       bgColor: "#DBEAFE",
//       borderColor: "#BFDBFE",
//       textColor: "#1E3A8A",
//     },
//     {
//       id: "slow",
//       label: "Service was very slow",
//       icon: "⏱",
//       bgColor: "#FEF3C7",
//       borderColor: "#FDE68A",
//       textColor: "#92400E",
//     },
//     {
//       id: "communication",
//       label: "Poor communication",
//       icon: "💬",
//       bgColor: "#FEE2E2",
//       borderColor: "#FECACA",
//       textColor: "#991B1B",
//     },
//     {
//       id: "value",
//       label: "Value for money",
//       icon: "💲",
//       bgColor: "#E0F2FE",
//       borderColor: "#BAE6FD",
//       textColor: "#0C4A6E",
//     },
//     {
//       id: "unsatisfied",
//       label: "Not satisfied with the work",
//       icon: "😕",
//       bgColor: "#EDE9FE",
//       borderColor: "#DDD6FE",
//       textColor: "#5B21B6",
//     },
//     {
//       id: "other",
//       label: "Other (please specify)",
//       icon: "✍",
//       bgColor: "#F3F4F6",
//       borderColor: "#E5E7EB",
//       textColor: "#374151",
//     },
//   ];

//   // Get final feedback text
//   const getFinalFeedback = () => {
//     const selected = feedbackOptions.find((opt) => opt.id === selectedOption);
//     if (selectedOption === "other") {
//       return otherFeedback;
//     } else if (selected) {
//       return selected.label;
//     }
//     return "";
//   };

//   // Submit data to the backend
//   const handleSubmit = async () => {
//     const totalAmount = order.price;
//     const commissionAmount = totalAmount * 0.05;
//     const netAmount = totalAmount - commissionAmount;
//     const finalFeedback = getFinalFeedback();

//     const payload = {
//       orderId: order.Id,
//       // order_number: order.order_number,
//       servitorId: order.servitor_id,
//       userId: order.userId,
//       serviceId: order.serviceId,
//       serviceType: order.Service?.services_name || "Unknown",
//       totalAmount,
//       commissionAmount,
//       netAmount,
//       rating,
//       feedback: finalFeedback,
//     };

//     console.log("Data",payload);

//     try {
//       setSubmitting(true);
//       const response = await fetch(`${URL}/orders/${order.Id}/completeTransaction`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload),
//       });
//       if (response.ok) {
//         // Hide the Transaction modal and show Thank You modal
//         setShowThankYou(true);
//       } else {
//         const text = await response.text();
//         let errorData;
//         try {
//           errorData = text ? JSON.parse(text) : { message: text };
//         } catch (e) {
//           errorData = { message: text };
//         }
//         console.error("Failed to complete transaction:", errorData.message);
//       }
//     } catch (error) {
//       console.error("Error completing transaction:", error);
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   const handleThankYouClose = () => {
//     setShowThankYou(false);
//     onSuccess();
//   };

//   // Separate first six options and the "other" option
//   const firstSixOptions = feedbackOptions.slice(0, 6);
//   const otherOption = feedbackOptions[6];

//   // If submission is successful, render only the Thank You modal
//   if (showThankYou) {
//     return <ThankYouModal onClose={handleThankYouClose} />;
//   }

//   return (
//     <Modal
//       show
//       onHide={onClose}
//       centered
//       backdrop="static"
//       keyboard={false}
//       style={{ marginTop: "20px" }}
//       dialogClassName="custom-wide-modal"
//       className="transaction-modal" 
//     >
//       {/* Header */}
//       <Modal.Header
//         style={{
//           borderBottom: "1px solid #e5e7eb",
//           padding: "1rem 1.5rem",
//           position: "relative",
//         }}
//       >
//         <button
//           type="button"
//           onClick={onClose}
//           style={{
//             position: "absolute",
//             top: "0.75rem",
//             right: "1rem",
//             backgroundColor: "transparent",
//             border: "none",
//             color: "#6b7280",
//             cursor: "pointer",
//             padding: "0.25rem",
//             borderRadius: "0.25rem",
//           }}
//           onMouseOver={(e) => (e.currentTarget.style.color = "#000")}
//           onMouseOut={(e) => (e.currentTarget.style.color = "#6b7280")}
//         >
//           <X size={20} />
//         </button>
//         <Modal.Title style={{ fontSize: "1.25rem", fontWeight: "bold", margin: "0 auto" }}>
//           Complete Service Transaction
//         </Modal.Title>
//       </Modal.Header>

//       {/* Body */}
//       <Modal.Body style={{ padding: "1.5rem" }}>
//         <p style={{ color: "#4b5563", margin: 0, marginBottom: "1rem", fontSize: "0.95rem" }}>
//           Thank you for taking{" "}
//           <span style={{ fontWeight: 600 }}>
//             {order.Service ? order.Service.services_name : "the service"}
//           </span>{" "}
//           from us. Stay with HelpNao.
//         </p>
//         <hr style={{ marginBottom: "1rem" }} />

//         {/* Star Rating */}
//         <StarRating rating={rating} setRating={setRating} />

//         {/* Feedback Options */}
//         <h3 style={{ fontSize: "1rem", fontWeight: "600", marginBottom: "1rem" }}>
//           How was your experience?
//         </h3>

//         {/* 2-column grid for first six options */}
//         <div className="feedback-grid">
//           {firstSixOptions.map((option) => {
//             const isSelected = selectedOption === option.id;
//             return (
//               <label
//                 key={option.id}
//                 className={`feedback-option ${isSelected ? "selected" : ""}`}
//                 onClick={() => {
//                   setSelectedOption(option.id);
//                   if (option.id !== "other") setOtherFeedback("");
//                 }}
//               >
//                 <input
//                   type="radio"
//                   name="feedback"
//                   value={option.id}
//                   checked={selectedOption === option.id}
//                   readOnly
//                   style={{ width: "1rem", height: "1rem" }}
//                 />
//                  <span className="option-icon">{option.icon}</span>
//                  <span className="option-label">{option.label}</span>
//               </label>
//             );
//           })}
//         </div>

//         {/* "Other" option full row */}
//         <div
//           style={{
//             marginTop: "0.75rem",
//             display: "flex",
//             alignItems: "center",
//             padding: "0.75rem",
//             borderRadius: "0.75rem",
//             cursor: "pointer",
//             transition: "all 0.2s",
//             border:
//               selectedOption === otherOption.id
//                 ? `2px solid ${otherOption.borderColor}`
//                 : "1px solid #e5e7eb",
//             backgroundColor: selectedOption === otherOption.id ? otherOption.bgColor : "#fff",
//           }}
//           onClick={() => setSelectedOption(otherOption.id)}
//         >
//           <input
//             type="radio"
//             name="feedback"
//             value={otherOption.id}
//             checked={selectedOption === otherOption.id}
//             readOnly
//             style={{ width: "1rem", height: "1rem" }}
//           />
//           <span style={{ marginLeft: "0.75rem", fontSize: "1.2rem" }}>{otherOption.icon}</span>
//           <span
//             style={{
//               marginLeft: "0.5rem",
//               fontSize: "0.95rem",
//               color: selectedOption === otherOption.id ? otherOption.textColor : "#374151",
//             }}
//           >
//             {otherOption.label}
//           </span>
//         </div>

//         {/* Textarea for "Other" feedback */}
//         {selectedOption === "other" && (
//           <div style={{ marginTop: "1rem" }}>
//             <label
//               style={{
//                 display: "block",
//                 marginBottom: "0.5rem",
//                 fontSize: "0.9rem",
//                 fontWeight: 500,
//                 color: "#374151",
//               }}
//             >
//               Please provide more details
//             </label>
//             <textarea
//               value={otherFeedback}
//               onChange={(e) => setOtherFeedback(e.target.value)}
//               style={{
//                 width: "100%",
//                 height: "80px",
//                 padding: "0.75rem",
//                 borderRadius: "0.75rem",
//                 border: "1px solid #e5e7eb",
//                 fontSize: "0.9rem",
//                 resize: "none",
//                 outline: "none",
//               }}
//               placeholder="Tell us more about your experience..."
//             />
//           </div>
//         )}
//       </Modal.Body>

//       {/* Footer */}
//       <Modal.Footer
//         style={{
//           borderTop: "1px solid #e5e7eb",
//           padding: "1rem 1.5rem",
//           display: "flex",
//           gap: "1rem",
//           backgroundColor: "#f9fafb",
//           borderRadius: "0 0 0.75rem 0.75rem",
//         }}
//       >
//         <Button
//           onClick={onClose}
//           disabled={submitting}
//           style={{
//             flex: 1,
//             padding: "0.75rem 1rem",
//             border: "1px solid #d1d5db",
//             borderRadius: "0.75rem",
//             fontSize: "0.95rem",
//             fontWeight: 500,
//             color: "#374151",
//             backgroundColor: "#fff",
//           }}
//         >
//           Cancel
//         </Button>
//         <Button
//           onClick={handleSubmit}
//           disabled={submitting}
//           style={{
//             flex: 1,
//             padding: "0.75rem 1rem",
//             border: "none",
//             borderRadius: "0.75rem",
//             fontSize: "0.95rem",
//             fontWeight: 500,
//             color: "#fff",
//             backgroundColor: "#3B82F6",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             gap: "0.5rem",
//           }}
//           onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#2563EB")}
//           onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#3B82F6")}
//         >
//           <Send size={16} />
//           {submitting ? "Submitting..." : "Submit Feedback"}
//         </Button>
//       </Modal.Footer>
//     </Modal>
//   );
// };

// export default TransactionModal;

// ***** Upper code is all okay checked (9-7-25) ***** //




// ***** Add Translator EN BN (9-7-25) ***** //

// import React, { useState, useRef } from "react";
// import { Modal, Button } from "react-bootstrap";
// import { Star, X, Send, Wand2, ThumbsUp, Timer, MessageCircle, Banknote , Frown, Pencil } from "lucide-react";
// import { useTranslation } from "react-i18next";
// import { URL } from "../../../config";
// import "./TransactionModal.css";


// // Star rating component
// const StarRating = ({ rating, setRating, error }) => {
//   const { t } = useTranslation();
  
//   const starValues = [1, 2, 3, 4, 5];
//   return (
//     <div style={{ marginBottom: "1.5rem" }}>
//       <h3 style={{ fontSize: "1rem", fontWeight: "600", marginBottom: "1rem", textAlign: "center" }}>
//         {/* Rate your experience */}
//         {t("transactionModal.rateExperience")}
//       </h3>
//       <div style={{ display: "flex", justifyContent: "center", gap: "0.5rem" }}>
//         {starValues.map((value) => {
//           const isFilled = value <= rating;
//           return (
//             <button
//               key={value}
//               onClick={() => setRating(value)}
//               onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
//               onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
//               style={{
//                 backgroundColor: "transparent",
//                 border: "none",
//                 cursor: "pointer",
//                 transform: "scale(1)",
//                 transition: "transform 0.2s",
//                 padding: 0,
//               }}
//               title={
//                 value === 1
//                   ? "Very Poor"
//                   : value === 2
//                   ? "Poor"
//                   : value === 3
//                   ? "Average"
//                   : value === 4
//                   ? "Good"
//                   : "Excellent"
//               }
//             >
//               <Star
//                 size={32}
//                 style={{
//                   color: isFilled ? "#FBBF24" : "#D1D5DB",
//                   fill: isFilled ? "#FBBF24" : "none",
//                   transition: "color 0.2s",
//                 }}
//               />
//             </button>
//           );
//         })}
//       </div>
//       {error && <div className="error-text">{error}</div>}
//     </div>
//   );
// };

// // "Thank You" modal displayed after successful submission
// const ThankYouModal = ({ onClose }) => {
//   const { t } = useTranslation();
  
//   return (
//     <Modal show onHide={onClose} centered dialogClassName="thank-you-dialog">
//       <Modal.Header
//         style={{
//           borderBottom: "1px solid #e5e7eb",
//           padding: "1rem 1.5rem",
//           position: "relative",
//         }}
//       >
//         <button
//           type="button"
//           onClick={onClose}
//           style={{
//             position: "absolute",
//             top: "0.75rem",
//             right: "1rem",
//             backgroundColor: "transparent",
//             border: "none",
//             color: "#6b7280",
//             cursor: "pointer",
//             padding: "0.25rem",
//             borderRadius: "0.25rem",
//           }}
//           onMouseOver={(e) => (e.currentTarget.style.color = "#000")}
//           onMouseOut={(e) => (e.currentTarget.style.color = "#6b7280")}
//         >
//           <X size={20} />
//         </button>
//         <Modal.Title style={{ fontWeight: "bold", fontSize: "1.2rem", margin: "0 auto" }}>
//           {/* Thank You! */}
//           {t("transactionModal.thankYouTitle")}
//         </Modal.Title>
//       </Modal.Header>
//       <Modal.Body style={{ textAlign: "center", padding: "1.5rem" }}>
//         <p style={{ fontSize: "1rem", margin: 0 }}>
//           {/* Thank you for your feedback! We appreciate your time and trust in our service.
//           We hope to serve you again soon. */}

//           {t("transactionModal.thankYouMessage2")}
//         </p>
//         {/* <strong>Stay with HelpNao 😃</strong> */}
//         <strong>{t("transactionModal.stayWithHelpNao")}</strong>
//       </Modal.Body>
//       <Modal.Footer style={{ justifyContent: "center", borderTop: "1px solid #e5e7eb" }}>
//         <Button variant="primary" onClick={onClose} style={{ padding: "0.5rem 1.5rem" }}>
//           {/* OK */}
//           {t("transactionModal.okButton")}
//         </Button>
//       </Modal.Footer>
//     </Modal>
//   );
// };

// const TransactionModal = ({ order, onClose, onSuccess }) => {
//   const { t } = useTranslation();

//   const [rating, setRating] = useState(0);
//   const [ratingError, setRatingError] = useState("");
  
//   const [selectedOption, setSelectedOption] = useState("");
//   const [otherFeedback, setOtherFeedback] = useState("");
//   const [submitting, setSubmitting] = useState(false);
//   const [showThankYou, setShowThankYou] = useState(false);

//   const [feedbackError, setFeedbackError] = useState("");
//   const otherRef = useRef(null);


//   // feedback options
//   const feedbackOptions = [
//     {
//       id: "excellent",
//       // label: "Excellent experience",
//       label: t("transactionModal.feedbackOptions.excellent"),
//       // icon: "🌟",
//       icon: Wand2,
//       bgColor: "#D1FAE5",
//       borderColor: "#A7F3D0",
//       textColor: "#065F46",
//     },
//     {
//       id: "good",
//       // label: "Good service",
//       label: t("transactionModal.feedbackOptions.good"),
//       // icon: "👍",
//       icon: ThumbsUp,
//       bgColor: "#DBEAFE",
//       borderColor: "#BFDBFE",
//       textColor: "#1E3A8A",
//     },
//     {
//       id: "slow",
//       // label: "Service was very slow",
//       label: t("transactionModal.feedbackOptions.slow"),
//       // icon: "⏱",
//       icon: Timer, 
//       bgColor: "#FEF3C7",
//       borderColor: "#FDE68A",
//       textColor: "#92400E",
//     },
//     {
//       id: "communication",
//       // label: "Poor communication",
//       label: t("transactionModal.feedbackOptions.communication"),
//       // icon: "💬",
//       icon: MessageCircle,
//       bgColor: "#FEE2E2",
//       borderColor: "#FECACA",
//       textColor: "#991B1B",
//     },
//     {
//       id: "value",
//       // label: "Value for money",
//       label: t("transactionModal.feedbackOptions.value"),
//       // icon: "💸",
//       icon: Banknote , 
//       bgColor: "#E0F2FE",
//       borderColor: "#BAE6FD",
//       textColor: "#0C4A6E",
//     },
//     {
//       id: "unsatisfied",
//       // label: "Not satisfied with the work",
//       label: t("transactionModal.feedbackOptions.unsatisfied"),
//       // icon: "😕",
//       icon: Frown, 
//       bgColor: "#EDE9FE",
//       borderColor: "#DDD6FE",
//       textColor: "#5B21B6",
//     },
//     {
//       id: "other",
//       // label: "Other (please specify)",
//       label: t("transactionModal.feedbackOptions.other"),
//       // icon: "✍",
//       icon: Pencil,
//       bgColor: "#F3F4F6",
//       borderColor: "#E5E7EB",
//       textColor: "#374151",
//     },
//   ];

//   // Get final feedback text
//   const getFinalFeedback = () => {
//     const selected = feedbackOptions.find((opt) => opt.id === selectedOption);
//     if (selectedOption === "other") {
//       return otherFeedback;
//     } else if (selected) {
//       return selected.label;
//     }
//     return "";
//   };

//   // Submit data to the backend
//   const handleSubmit = async () => {
//     // 1) Validate rating
//     if (rating === 0) {
//       setRatingError(t("transactionModal.errors.giveRating"));
//       return;
//     }
//     setRatingError("");

//     // 2) Validate feedback selection
//     if (!selectedOption) {
//       setFeedbackError(t("transactionModal.errors.selectFeedback"));
//       return;
//     }
//     setFeedbackError("");

//     // 3) If "other", ensure text
//     if (selectedOption === "other" && otherFeedback.trim() === "") {
//       setFeedbackError(t("transactionModal.errors.writeFeedback"));
//       otherRef.current?.focus();
//       return;
//     }
//     setFeedbackError("");

//     const totalAmount = order.price;
//     const isTutor =
//       ((order.Service?.services_name || order.service_name || "") + "")
//         .toLowerCase() === "tutor service";
//     const commissionAmount = isTutor ? 0 : totalAmount * 0.05;
//     // const commissionAmount = totalAmount * 0.05;
//     const netAmount = totalAmount - commissionAmount;
//     const finalFeedback = getFinalFeedback();

//     const payload = {
//       orderId: order.Id,
//       // order_number: order.order_number,
//       servitorId: order.servitor_id,
//       userId: order.userId,
//       serviceId: order.serviceId,
//       serviceType: order.Service?.services_name || "Unknown",
//       totalAmount,
//       commissionAmount,
//       netAmount,
//       rating,
//       feedback: finalFeedback,
//     };

//     console.log("Data",payload);

//     try {
//       setSubmitting(true);
//       const response = await fetch(`${URL}/orders/${order.Id}/completeTransaction`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload),
//       });
//       if (response.ok) {
//         // Hide the Transaction modal and show Thank You modal
//         setShowThankYou(true);
//       } else {
//         const text = await response.text();
//         let errorData;
//         try {
//           errorData = text ? JSON.parse(text) : { message: text };
//         } catch (e) {
//           errorData = { message: text };
//         }
//         console.error("Failed to complete transaction:", errorData.message);
//       }
//     } catch (error) {
//       console.error("Error completing transaction:", error);
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   const handleThankYouClose = () => {
//     setShowThankYou(false);
//     onSuccess();
//   };

//   // Separate first six options and the "other" option
//   const firstSixOptions = feedbackOptions.slice(0, 6);
//   const otherOption = feedbackOptions[6];
//   const OtherIcon = otherOption.icon;

//   // If submission is successful, render only the Thank You modal
//   if (showThankYou) {
//     return <ThankYouModal onClose={handleThankYouClose} />;
//   }

//   return (
//     <Modal
//       show
//       onHide={onClose}
//       centered
//       scrollable
//       backdrop="static"
//       keyboard={false}
//       style={{ marginTop: "20px" }}
//       dialogClassName="custom-wide-modal"
//       className="transaction-modal" 
//     >
//       {/* Header */}
//       <Modal.Header
//         style={{
//           borderBottom: "1px solid #e5e7eb",
//           padding: "1rem 1.5rem",
//           position: "relative",
//         }}
//       >
//         <button
//           type="button"
//           onClick={onClose}
//           style={{
//             position: "absolute",
//             top: "0.75rem",
//             right: "1rem",
//             backgroundColor: "transparent",
//             border: "none",
//             color: "#6b7280",
//             cursor: "pointer",
//             padding: "0.25rem",
//             borderRadius: "0.25rem",
//           }}
//           onMouseOver={(e) => (e.currentTarget.style.color = "#000")}
//           onMouseOut={(e) => (e.currentTarget.style.color = "#6b7280")}
//         >
//           <X size={20} />
//         </button>
//         <Modal.Title style={{ fontSize: "1.25rem", fontWeight: "bold", margin: "0 auto" }}>
//           {/* Complete Service Transaction */}
//           {t("transactionModal.title")}
//         </Modal.Title>
//       </Modal.Header>

//       {/* Body */}
//       <Modal.Body style={{ padding: "1.5rem" }}>
//         {/* <p style={{ color: "#4b5563", margin: 0, marginBottom: "1rem", fontSize: "0.95rem" }}>
//           Thank you for taking{" "}
//           <span style={{ fontWeight: 600 }}>
//             {order.Service ? order.Service.services_name : "the service"}
//           </span>{" "}
//           from us. Stay with HelpNao.
//         </p> */}
//         <p style={{ color: "#4b5563", margin: 0, marginBottom: "1rem", fontSize: "0.95rem" }}>
//           {t("transactionModal.thankYouMessage1", { service: order.Service ? order.Service.services_name : "the service" })}
//           {" "}
//           {t("transactionModal.stayWithHelpNao")}
//         </p>
//         <hr style={{ marginBottom: "1rem" }} />

//         {/* Star Rating */}
//         {/* <StarRating rating={rating} setRating={setRating} /> */}
//         <StarRating
//           rating={rating}
//           setRating={(r) => {
//             setRating(r);
//             setRatingError("");
//           }}
//           error={ratingError}
//         />

//         {/* Feedback Options */}
//         <h3 style={{ fontSize: "1rem", fontWeight: "600", marginBottom: "1rem" }}>
//           {/* How was your experience? */}
//           {t("transactionModal.howWasExperience")}
//         </h3>

//         {feedbackError && selectedOption !== "other" && (
//          <div className="error-text" style={{ marginBottom: "0.5rem" }}>
//            {feedbackError}
//          </div>
//        )}

//         {/* 2-column grid for first six options */}
//         <div className="feedback-grid">
//           {firstSixOptions.map((option) => {
//             const isSelected = selectedOption === option.id;
//             const Icon = option.icon;

//             return (
//               <label
//                 key={option.id}
//                 className={`feedback-option ${isSelected ? "selected" : ""}`}
//                 onClick={() => {
//                   setSelectedOption(option.id);
//                   if (option.id !== "other") setOtherFeedback("");
//                 }}
//               >
//                 <input
//                   type="radio"
//                   name="feedback"
//                   value={option.id}
//                   checked={selectedOption === option.id}
//                   readOnly
//                   style={{ width: "1rem", height: "1rem" }}
//                 />
//                  {/* <span className="option-icon">{option.icon}</span> */}


//                 <span className="option-icon">
//                   <Icon size={18} />
//                 </span>


//                  <span className="option-label">{option.label}</span>
//               </label>
//             );
//           })}
//         </div>

//         {/* "Other" option full row */}
//         <div
//           style={{
//             marginTop: "0.75rem",
//             display: "flex",
//             alignItems: "center",
//             padding: "0.75rem",
//             borderRadius: "0.75rem",
//             cursor: "pointer",
//             transition: "all 0.2s",
//             border:
//               selectedOption === otherOption.id
//                 ? `2px solid ${otherOption.borderColor}`
//                 : "1px solid #e5e7eb",
//             backgroundColor: selectedOption === otherOption.id ? otherOption.bgColor : "#fff",
//           }}
//           onClick={() => setSelectedOption(otherOption.id)}
//         >
//           <input
//             type="radio"
//             name="feedback"
//             value={otherOption.id}
//             checked={selectedOption === otherOption.id}
//             readOnly
//             style={{ width: "1rem", height: "1rem" }}
//           />
//           {/* <span style={{ marginLeft: "0.75rem", fontSize: "1.2rem" }}>{otherOption.icon}</span> */}

//           <OtherIcon size={18} style={{ marginLeft: "0.75rem" }} />
          
//           <span
//             style={{
//               marginLeft: "0.5rem",
//               fontSize: "0.95rem",
//               color: selectedOption === otherOption.id ? otherOption.textColor : "#374151",
//             }}
//           >
//             {otherOption.label}
//           </span>
//         </div>

//         {/* Textarea for "Other" feedback */}
//         {selectedOption === "other" && (
//           <div style={{ marginTop: "1rem" }}>
//             <label
//               style={{
//                 display: "block",
//                 marginBottom: "0.5rem",
//                 fontSize: "0.9rem",
//                 fontWeight: 500,
//                 color: "#374151",
//               }}
//             >
//               {/* Please provide more details */}
//               {t("transactionModal.otherDetailsLabel")}
//             </label>
//             <textarea
//               value={otherFeedback}
//               ref={otherRef}
//               onChange={(e) => setOtherFeedback(e.target.value)}
//               style={{
//                 width: "100%",
//                 height: "80px",
//                 padding: "0.75rem",
//                 borderRadius: "0.75rem",
//                 border: "1px solid #e5e7eb",
//                 fontSize: "0.9rem",
//                 resize: "none",
//                 outline: "none",
//               }}
//               // placeholder="Tell us more about your experience..."
//               placeholder={t("transactionModal.otherPlaceholder")}
//             />

//             {feedbackError && selectedOption === "other" && (
//              <div className="error-text">{feedbackError}</div>
//            )}
//           </div>
//         )}
//       </Modal.Body>

//       {/* Footer */}
//       <Modal.Footer
//         style={{
//           borderTop: "1px solid #e5e7eb",
//           padding: "1rem 1.5rem",
//           display: "flex",
//           gap: "1rem",
//           backgroundColor: "#f9fafb",
//           borderRadius: "0 0 0.75rem 0.75rem",
//         }}
//       >
//         <Button
//           onClick={onClose}
//           disabled={submitting}
//           style={{
//             flex: 1,
//             padding: "0.75rem 1rem",
//             border: "1px solid #d1d5db",
//             borderRadius: "0.75rem",
//             fontSize: "0.95rem",
//             fontWeight: 500,
//             color: "#374151",
//             backgroundColor: "#fff",
//           }}
//         >
//           {/* Cancel */}
//           {t("transactionModal.cancelButton")}
//         </Button>
//         <Button
//           onClick={handleSubmit}
//           disabled={submitting}
//           style={{
//             flex: 1,
//             padding: "0.75rem 1rem",
//             border: "none",
//             borderRadius: "0.75rem",
//             fontSize: "0.95rem",
//             fontWeight: 500,
//             color: "#fff",
//             backgroundColor: "#3B82F6",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             gap: "0.5rem",
//           }}
//           onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#2563EB")}
//           onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#3B82F6")}
//         >
//           <Send size={16} />
//           {/* {submitting ? "Submitting..." : "Submit Feedback"} */}
//           {submitting ? t("transactionModal.submittingButton") : t("transactionModal.submitButton")}
//         </Button>
//       </Modal.Footer>
//     </Modal>
//   );
// };

// export default TransactionModal;










import React, { useState, useRef } from "react";
import { Modal, Button } from "react-bootstrap";
import {
  Star,
  X,
  Send,
  Wand2,
  ThumbsUp,
  Timer,
  MessageCircle,
  // Banknote,
  Frown,
  Pencil,
  ShieldCheck,
  AlertTriangle,
  AlertCircle,
  // XOctagon,
} from "lucide-react";
import { useTranslation } from "react-i18next";
import { URL } from "../../../config";
import "./TransactionModal.css";

// Star rating component
const StarRating = ({ rating, setRating, error }) => {
  const { t } = useTranslation();

  const starValues = [1, 2, 3, 4, 5];
  return (
    <div style={{ marginBottom: "1.5rem" }}>
      <h3
        style={{
          fontSize: "1rem",
          fontWeight: "600",
          marginBottom: "1rem",
          textAlign: "center",
        }}
      >
        {t("transactionModal.rateExperience")}
      </h3>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "0.5rem",
        }}
      >
        {starValues.map((value) => {
          const isFilled = value <= rating;
          return (
            <button
              key={value}
              onClick={() => setRating(value)}
              onMouseOver={(e) =>
                (e.currentTarget.style.transform = "scale(1.1)")
              }
              onMouseOut={(e) =>
                (e.currentTarget.style.transform = "scale(1)")
              }
              style={{
                backgroundColor: "transparent",
                border: "none",
                cursor: "pointer",
                transform: "scale(1)",
                transition: "transform 0.2s",
                padding: 0,
              }}
              title={
                value === 1
                  ? "Very Poor"
                  : value === 2
                  ? "Poor"
                  : value === 3
                  ? "Average"
                  : value === 4
                  ? "Good"
                  : "Excellent"
              }
            >
              <Star
                size={32}
                style={{
                  color: isFilled ? "#FBBF24" : "#D1D5DB",
                  fill: isFilled ? "#FBBF24" : "none",
                  transition: "color 0.2s",
                }}
              />
            </button>
          );
        })}
      </div>
      {error && <div className="error-text">{error}</div>}
    </div>
  );
};

// "Thank You" modal displayed after successful submission
const ThankYouModal = ({ onClose }) => {
  const { t } = useTranslation();

  return (
    <Modal show onHide={onClose} centered dialogClassName="thank-you-dialog">
      <Modal.Header
        style={{
          borderBottom: "1px solid #e5e7eb",
          padding: "1rem 1.5rem",
          position: "relative",
        }}
      >
        <button
          type="button"
          onClick={onClose}
          style={{
            position: "absolute",
            top: "0.75rem",
            right: "1rem",
            backgroundColor: "transparent",
            border: "none",
            color: "#6b7280",
            cursor: "pointer",
            padding: "0.25rem",
            borderRadius: "0.25rem",
          }}
          onMouseOver={(e) => (e.currentTarget.style.color = "#000")}
          onMouseOut={(e) => (e.currentTarget.style.color = "#6b7280")}
        >
          <X size={20} />
        </button>
        <Modal.Title
          style={{
            fontWeight: "bold",
            fontSize: "1.2rem",
            margin: "0 auto",
          }}
        >
          {t("transactionModal.thankYouTitle")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ textAlign: "center", padding: "1.5rem" }}>
        <p style={{ fontSize: "1rem", margin: 0 }}>
          {t("transactionModal.thankYouMessage2")}
        </p>
        <strong>{t("transactionModal.stayWithHelpNao")}</strong>
      </Modal.Body>
      <Modal.Footer
        style={{
          justifyContent: "center",
          borderTop: "1px solid #e5e7eb",
        }}
      >
        <Button
          variant="primary"
          onClick={onClose}
          style={{ padding: "0.5rem 1.5rem" }}
        >
          {t("transactionModal.okButton")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const TransactionModal = ({ order, onClose, onSuccess }) => {
  const { t } = useTranslation();

  const [rating, setRating] = useState(0);
  const [ratingError, setRatingError] = useState("");

  const [selectedOption, setSelectedOption] = useState("");
  const [otherFeedback, setOtherFeedback] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [showThankYou, setShowThankYou] = useState(false);

  const [feedbackError, setFeedbackError] = useState("");
  const otherRef = useRef(null);

  // feedback options (service-focused, professional)
  const feedbackOptions = [
    {
      id: "excellent",
      label: t("transactionModal.feedbackOptions.excellent"),
      icon: Wand2,
      bgColor: "#D1FAE5",
      borderColor: "#A7F3D0",
      textColor: "#065F46",
    },
    {
      id: "good",
      label: t("transactionModal.feedbackOptions.good"),
      icon: ThumbsUp,
      bgColor: "#DBEAFE",
      borderColor: "#BFDBFE",
      textColor: "#1E3A8A",
    },
    {
      id: "quality_great",
      label: t("transactionModal.feedbackOptions.qualityGreat"),
      icon: ShieldCheck,
      bgColor: "#ECFDF3",
      borderColor: "#BBF7D0",
      textColor: "#166534",
    },
    {
      id: "slow",
      label: t("transactionModal.feedbackOptions.slow"),
      icon: Timer,
      bgColor: "#FEF3C7",
      borderColor: "#FDE68A",
      textColor: "#92400E",
    },
    {
      id: "communication",
      label: t("transactionModal.feedbackOptions.communication"),
      icon: MessageCircle,
      bgColor: "#FEE2E2",
      borderColor: "#FECACA",
      textColor: "#991B1B",
    },
    // {
    //   id: "value",
    //   label: t("transactionModal.feedbackOptions.value"),
    //   icon: Banknote,
    //   bgColor: "#E0F2FE",
    //   borderColor: "#BAE6FD",
    //   textColor: "#0C4A6E",
    // },
    {
      id: "bad_behavior",
      label: t("transactionModal.feedbackOptions.badBehavior"),
      icon: AlertTriangle,
      bgColor: "#FEF2F2",
      borderColor: "#FECACA",
      textColor: "#B91C1C",
    },
    {
      id: "extra_charge",
      label: t("transactionModal.feedbackOptions.extraCharge"),
      icon: AlertCircle,
      bgColor: "#FEF3C7",
      borderColor: "#FDE68A",
      textColor: "#92400E",
    },
    // {
    //   id: "not_completed",
    //   label: t("transactionModal.feedbackOptions.notCompleted"),
    //   icon: XOctagon,
    //   bgColor: "#EDE9FE",
    //   borderColor: "#DDD6FE",
    //   textColor: "#5B21B6",
    // },
    {
      id: "unsatisfied",
      label: t("transactionModal.feedbackOptions.unsatisfied"),
      icon: Frown,
      bgColor: "#F3E8FF",
      borderColor: "#E9D5FF",
      textColor: "#6B21A8",
    },
    {
      id: "other",
      label: t("transactionModal.feedbackOptions.other"),
      icon: Pencil,
      bgColor: "#F3F4F6",
      borderColor: "#E5E7EB",
      textColor: "#374151",
    },
  ];

  // Get final feedback text
  const getFinalFeedback = () => {
    const selected = feedbackOptions.find((opt) => opt.id === selectedOption);
    if (selectedOption === "other") {
      return otherFeedback;
    } else if (selected) {
      return selected.label;
    }
    return "";
  };

  // Submit data to the backend
  const handleSubmit = async () => {
    // 1) Validate rating
    if (rating === 0) {
      setRatingError(t("transactionModal.errors.giveRating"));
      return;
    }
    setRatingError("");

    // 2) Validate feedback selection
    if (!selectedOption) {
      setFeedbackError(t("transactionModal.errors.selectFeedback"));
      return;
    }
    setFeedbackError("");

    // 3) If "other", ensure text
    if (selectedOption === "other" && otherFeedback.trim() === "") {
      setFeedbackError(t("transactionModal.errors.writeFeedback"));
      otherRef.current?.focus();
      return;
    }
    setFeedbackError("");

    const totalAmount = order.price;
    const isTutor =
      ((order.Service?.services_name || order.service_name || "") + "")
        .toLowerCase() === "tutor service";
    const commissionAmount = isTutor ? 0 : totalAmount * 0.05;
    const netAmount = totalAmount - commissionAmount;
    const finalFeedback = getFinalFeedback();

    const payload = {
      orderId: order.Id,
      servitorId: order.servitor_id,
      userId: order.userId,
      serviceId: order.serviceId,
      serviceType: order.Service?.services_name || "Unknown",
      totalAmount,
      commissionAmount,
      netAmount,
      rating,
      feedback: finalFeedback,
    };

    // console.log("Data", payload);

    try {
      setSubmitting(true);
      const response = await fetch(
        `${URL}/orders/${order.Id}/completeTransaction`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );
      if (response.ok) {
        setShowThankYou(true);
      } else {
        const text = await response.text();
        let errorData;
        try {
          errorData = text ? JSON.parse(text) : { message: text };
        } catch (e) {
          errorData = { message: text };
        }
        console.error("Failed to complete transaction:", errorData.message);
      }
    } catch (error) {
      console.error("Error completing transaction:", error);
    } finally {
      setSubmitting(false);
    }
  };

  const handleThankYouClose = () => {
    setShowThankYou(false);
    onSuccess();
  };

  // main options vs "other"
  const mainOptions = feedbackOptions.filter((opt) => opt.id !== "other");
  const otherOption = feedbackOptions.find((opt) => opt.id === "other");
  const OtherIcon = otherOption.icon;

  // If submission is successful, render only the Thank You modal
  if (showThankYou) {
    return <ThankYouModal onClose={handleThankYouClose} />;
  }

  return (
    <Modal
      show
      onHide={onClose}
      centered
      scrollable
      backdrop="static"
      keyboard={false}
      style={{ marginTop: "20px" }}
      dialogClassName="custom-wide-modal"
      className="transaction-modal"
    >
      {/* Header */}
      <Modal.Header
        style={{
          borderBottom: "1px solid #e5e7eb",
          padding: "1rem 1.5rem",
          position: "relative",
        }}
      >
        <button
          type="button"
          onClick={onClose}
          style={{
            position: "absolute",
            top: "0.75rem",
            right: "1rem",
            backgroundColor: "transparent",
            border: "none",
            color: "#6b7280",
            cursor: "pointer",
            padding: "0.25rem",
            borderRadius: "0.25rem",
          }}
          onMouseOver={(e) => (e.currentTarget.style.color = "#000")}
          onMouseOut={(e) => (e.currentTarget.style.color = "#6b7280")}
        >
          <X size={20} />
        </button>
        <Modal.Title
          style={{
            fontSize: "1.25rem",
            fontWeight: "bold",
            margin: "0 auto",
          }}
        >
          {t("transactionModal.title")}
        </Modal.Title>
      </Modal.Header>

      {/* Body */}
      <Modal.Body style={{ padding: "1.5rem" }}>
        <p
          style={{
            color: "#4b5563",
            margin: 0,
            marginBottom: "1rem",
            fontSize: "0.95rem",
          }}
        >
          {t("transactionModal.thankYouMessage1", {
            service: order.Service
              ? order.Service.services_name
              : "the service",
          })}{" "}
          {t("transactionModal.stayWithHelpNao")}
        </p>

        {/* Order summary: order number + amount */}
        <div className="tm-order-summary">
          <div className="tm-order-summary-item">
            <span className="tm-order-summary-label">
              {t("transactionModal.orderSummary.orderNumber")}
            </span>
            <span className="tm-order-summary-value">
              {order.order_number}
            </span>
          </div>
          <div className="tm-order-summary-item">
            <span className="tm-order-summary-label">
              {t("transactionModal.orderSummary.amount")}
            </span>
            <span className="tm-order-summary-value">
              {order.price} Tk
            </span>
          </div>
        </div>

        <hr style={{ marginBottom: "1rem" }} />

        {/* Star Rating */}
        <StarRating
          rating={rating}
          setRating={(r) => {
            setRating(r);
            setRatingError("");
          }}
          error={ratingError}
        />

        {/* Feedback Options */}
        <h3
          style={{
            fontSize: "1rem",
            fontWeight: "600",
            marginBottom: "1rem",
          }}
        >
          {t("transactionModal.howWasExperience")}
        </h3>

        {feedbackError && selectedOption !== "other" && (
          <div
            className="error-text"
            style={{ marginBottom: "0.5rem" }}
          >
            {feedbackError}
          </div>
        )}

        {/* 2-column grid for main options */}
        <div className="feedback-grid">
          {mainOptions.map((option) => {
            const isSelected = selectedOption === option.id;
            const Icon = option.icon;

            return (
              <label
                key={option.id}
                className={`feedback-option ${
                  isSelected ? "selected" : ""
                }`}
                onClick={() => {
                  setSelectedOption(option.id);
                  if (option.id !== "other") setOtherFeedback("");
                }}
                style={{
                  borderColor: isSelected
                    ? option.borderColor
                    : undefined,
                  backgroundColor: isSelected
                    ? option.bgColor
                    : undefined,
                  color: isSelected
                    ? option.textColor
                    : undefined,
                }}
              >
                <input
                  type="radio"
                  name="feedback"
                  value={option.id}
                  checked={selectedOption === option.id}
                  readOnly
                  style={{ width: "1rem", height: "1rem" }}
                />
                <span className="option-icon">
                  <Icon size={18} />
                </span>
                <span className="option-label">{option.label}</span>
              </label>
            );
          })}
        </div>

        {/* "Other" option full row */}
        {otherOption && (
          <div
            style={{
              marginTop: "0.75rem",
              display: "flex",
              alignItems: "center",
              padding: "0.75rem",
              borderRadius: "0.75rem",
              cursor: "pointer",
              transition: "all 0.2s",
              border:
                selectedOption === otherOption.id
                  ? `2px solid ${otherOption.borderColor}`
                  : "1px solid #e5e7eb",
              backgroundColor:
                selectedOption === otherOption.id
                  ? otherOption.bgColor
                  : "#fff",
            }}
            onClick={() => setSelectedOption(otherOption.id)}
          >
            <input
              type="radio"
              name="feedback"
              value={otherOption.id}
              checked={selectedOption === otherOption.id}
              readOnly
              style={{ width: "1rem", height: "1rem" }}
            />
            <OtherIcon
              size={18}
              style={{ marginLeft: "0.75rem" }}
            />
            <span
              style={{
                marginLeft: "0.5rem",
                fontSize: "0.95rem",
                color:
                  selectedOption === otherOption.id
                    ? otherOption.textColor
                    : "#374151",
              }}
            >
              {otherOption.label}
            </span>
          </div>
        )}

        {/* Textarea for "Other" feedback */}
        {selectedOption === "other" && (
          <div style={{ marginTop: "1rem" }}>
            <label
              style={{
                display: "block",
                marginBottom: "0.5rem",
                fontSize: "0.9rem",
                fontWeight: 500,
                color: "#374151",
              }}
            >
              {t("transactionModal.otherDetailsLabel")}
            </label>
            <textarea
              value={otherFeedback}
              ref={otherRef}
              onChange={(e) => setOtherFeedback(e.target.value)}
              style={{
                width: "100%",
                height: "80px",
                padding: "0.75rem",
                borderRadius: "0.75rem",
                border: "1px solid #e5e7eb",
                fontSize: "0.9rem",
                resize: "none",
                outline: "none",
              }}
              placeholder={t("transactionModal.otherPlaceholder")}
            />
            {feedbackError && selectedOption === "other" && (
              <div className="error-text">{feedbackError}</div>
            )}
          </div>
        )}
      </Modal.Body>

      {/* Footer */}
      <Modal.Footer
        style={{
          borderTop: "1px solid #e5e7eb",
          padding: "1rem 1.5rem",
          display: "flex",
          gap: "1rem",
          backgroundColor: "#f9fafb",
          borderRadius: "0 0 0.75rem 0.75rem",
        }}
      >
        <Button
          onClick={onClose}
          disabled={submitting}
          style={{
            flex: 1,
            padding: "0.75rem 1rem",
            border: "1px solid #d1d5db",
            borderRadius: "0.75rem",
            fontSize: "0.95rem",
            fontWeight: 500,
            color: "#374151",
            backgroundColor: "#fff",
          }}
        >
          {t("transactionModal.cancelButton")}
        </Button>
        <Button
          onClick={handleSubmit}
          disabled={submitting}
          style={{
            flex: 1,
            padding: "0.75rem 1rem",
            border: "none",
            borderRadius: "0.75rem",
            fontSize: "0.95rem",
            fontWeight: 500,
            color: "#fff",
            backgroundColor: "#3B82F6",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "0.5rem",
          }}
          onMouseOver={(e) =>
            (e.currentTarget.style.backgroundColor = "#2563EB")
          }
          onMouseOut={(e) =>
            (e.currentTarget.style.backgroundColor = "#3B82F6")
          }
        >
          <Send size={16} />
          {submitting
            ? t("transactionModal.submittingButton")
            : t("transactionModal.submitButton")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TransactionModal;
